import {useTranslate} from '@tolgee/react';
import {Button, Modal} from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import {useDispatch, useSelector} from 'react-redux';
import {setHelpMenuOpen} from '../../../redux/slices/communication';

export default function HelpModel() {
    const SECTIONS = [
        'help_section_functions_per_platform',
        'help_section_insta_direct_message_and_comments',
        'help_section_youtube_comments',
        'help_section_package',
        'help_section_request_test_period'
    ];

    const links = {
        "help_section_package": {
            "link": "https://lomavis.com/preise/cockpit-preise/",
        },
    }

    const {t} = useTranslate();
    const dispatch = useDispatch();
    const {
        ui: {helpMenuOpen}
    } = useSelector((state) => state.communication);

    // Wrap the return statement inside the component
    return (
        <Modal
            show={helpMenuOpen}
            onHide={() => {}}
            size="xl"
            centered
            className="help-modal"
        >
            <Modal.Header className="border-0">
                <Modal.Title> {t('lomavis_communication.helpModal.title')}</Modal.Title>
                <Button
                    variant="outline-secondary"
                    onClick={() => dispatch(setHelpMenuOpen(false))}
                >
                    <span className="fs-4" aria-hidden="true">
                        x
                    </span>
                </Button>
            </Modal.Header>
            <Modal.Body className="border-0">
                <Accordion>
                    {SECTIONS.map((name) => (
                        <Accordion.Item eventKey={name} key={name}>
                            <Accordion.Header>
                                <span className="fw-bold">
                                    {t(`lomavis_communication.helpModal.${name}_title`)}
                                </span>
                            </Accordion.Header>
                            <Accordion.Body style={{whiteSpace: 'break-spaces'}}>
                                {t(`lomavis_communication.helpModal.${name}_description`)}
                                {links[name] && (
                                    <a
                                        href={links[name].link}
                                        target="_blank"
                                    >
                                        {links[name].link}
                                    </a>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => dispatch(setHelpMenuOpen(false))}
                >
                    {t('lomavis_communication.helpModal.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
